import { useState, useCallback } from 'react';

const TOAST_DURATION_MS = 3000;

/**
 * Simple toast notification hook.
 * @returns {{ toast: {msg: string, type: string}|null, showToast: (msg: string, type?: string) => void }}
 */
export default function useToast() {
  const [toast, setToast] = useState(null);

  /** @param {string} msg @param {'success'|'error'} type */
  const showToast = useCallback((msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), TOAST_DURATION_MS);
  }, []);

  return { toast, showToast };
}
